import { axiosRubyClient } from '@/util/axios/axiosClient';

export interface CertificateEntry {
  type: string;
  label: string;
}

export interface Uniform {
  id: number;
  name: string;
}

export interface Skill {
  id: number;
  name: string;
  display_name_en: string;
  display_name_es: string;
  ai_enabled: boolean;
  english_only: boolean;
  gravy_trained: boolean;
  requestable: boolean;
  popular_pick: boolean;
  requires_uniform: boolean;
  requires_certificate: boolean;
  requires_assessment: boolean;
  default_uniform_id: number | null;
  requirements: string[];
  certificate: CertificateEntry[];
}

export interface SkillsIndexResponse {
  success: boolean;
  data: Skill[];
}

export interface SkillResponse {
  success: boolean;
  data: Skill;
}

export interface UniformsResponse {
  success: boolean;
  data: Uniform[];
}

export interface SkillUpdateData {
  ai_enabled?: boolean;
  english_only?: boolean;
  gravy_trained?: boolean;
  requestable?: boolean;
  popular_pick?: boolean;
  display_name_en?: string;
  display_name_es?: string;
  default_uniform_id?: number | null;
  requirements?: string[];
  certificate?: CertificateEntry[] | null;
}

export class SkillsAPI {
  /**
   * Get all active skills
   */
  static async getSkills(): Promise<SkillsIndexResponse> {
    const response = await axiosRubyClient.get('/api/admin/skills');
    return response.data;
  }

  /**
   * Update a skill
   */
  static async updateSkill(
    id: number,
    data: SkillUpdateData,
  ): Promise<SkillResponse> {
    const response = await axiosRubyClient.patch(`/api/admin/skills/${id}`, {
      skill: data,
    });
    return response.data;
  }

  /**
   * Get all uniforms for dropdown selection
   */
  static async getUniforms(): Promise<UniformsResponse> {
    const response = await axiosRubyClient.get('/api/admin/skills/uniforms');
    return response.data;
  }
}
